import React from 'react';

const StatsTitle = ({ title }) => {
  return (
    <h3 className='mb-10 text-2xl text-center text-ghostWhite'>{title}</h3>
  );
};

export default StatsTitle;
